import { UserCustomClipsSort } from '@sportybot-web/services/sporty-gateway/generated/graphql';
import { ReelsSortFieldOption } from '@sportybot-web/services/sporty-gateway/types';
import { z } from 'zod';

export const clipsSearchSchema = z.object({
  limit: z.number().default(16),
  page: z.number().default(0),
});

export const customClipsSearchSchema = z.object({
  description: z.string().optional(),
  gamePk: z.number().optional(),
  sortOrder: z.enum(UserCustomClipsSort).default(UserCustomClipsSort.CREATED_AT),
});

export const reelsSearchSchema = z.object({
  sortBy: z.enum(ReelsSortFieldOption).default(ReelsSortFieldOption.CREATED_AT),
  title: z.string().optional(),
});

export type ClipsSearchSchema = z.infer<typeof clipsSearchSchema>;
export type CustomClipSearchSchema = z.infer<typeof customClipsSearchSchema>;
export type ReelsSearchSchema = z.infer<typeof reelsSearchSchema>;
